// eslint-ignore
export default 
`<Input label="Small" size="sm"></Input>
<Input label="Medium (Default)"></Input>
<Input label="Large" size="lg"></Input>

<Input label="Small" placeholder="Click here" size="sm" inline></Input>
<Input label="Medium (Default)" placeholder="Click here" inline></Input>
<Input label="Large" placeholder="Click here" size="lg" inline></Input>


export default {
    components: { Input }
}`;